import { render } from "./AuraProcessingCostsTable.vue?vue&type=template&id=bbcfe720&ts=true"
import script from "./AuraProcessingCostsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraProcessingCostsTable.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/aura/components/AuraProcessingCostsTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bbcfe720"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bbcfe720', __exports__)) {
    api.reload('bbcfe720', __exports__)
  }
  
  module.hot.accept("./AuraProcessingCostsTable.vue?vue&type=template&id=bbcfe720&ts=true", () => {
    api.rerender('bbcfe720', render)
  })

}


export default __exports__